import store from '../store/store';

export default function getCustomerInfoTenantName(): string {
    const splitEmail = store.customerInfo.Email.split('@');
    const tenantName = splitEmail[1];
    return tenantName ?? 'UnknownTenant';
}

export function getIsInternalBooking(): boolean {
    const customerTenantName = getCustomerInfoTenantName();
    const organizerMailboxSplit = store.bookingMailbox?.split('@');
    const organizerTenantName = organizerMailboxSplit?.[1] ?? 'UnknownOrganizerTenant';

    return customerTenantName.toLocaleLowerCase() == organizerTenantName.toLocaleLowerCase();
}
